/**
 * Memória do último filtro do board (F1).
 * Guarda por usuário no localStorage; tolera storage bloqueado ou JSON inválido.
 */
const PREFIXO = 'board_filtro_v1_';

function chave() {
    return PREFIXO + (localStorage.getItem('user_id') || localStorage.getItem('id_assessor') || 'anon');
}

/** Salva só o essencial para reabrir o board: id e nome de cliente e mailing. */
export function salvarFiltroBoard({ cliente, mailing }) {
    try {
        const valor = {
            cliente: cliente && cliente.id ? { id: cliente.id, name: cliente.name } : null,
            mailing: mailing && mailing.id ? { id: mailing.id, name: mailing.name } : null,
            salvoEm: new Date().toISOString(),
        };
        localStorage.setItem(chave(), JSON.stringify(valor));
    } catch (e) { /* storage indisponível: segue sem memória */ }
}

export function lerFiltroBoard() {
    try {
        const valor = JSON.parse(localStorage.getItem(chave()) || 'null');
        if (!valor || typeof valor !== 'object') return null;
        return valor;
    } catch (e) {
        return null;
    }
}

export function limparFiltroBoard() {
    try { localStorage.removeItem(chave()); } catch (e) { /* nada */ }
}
